import { isRememberedHiddenMessage } from '../../lib/hiddenPrompts';
import { isHiddenAssistantPrompt } from '../AIEntityMentionsInput.utils';
import { useAIChatMessagesContext } from './context';
import Item from './Item';
import { getMessageText, isHiddenMessage } from './utils';

const List = () => {
  const { hideAssistantMessage, hideUserMessage, messages } = useAIChatMessagesContext();
  if (messages.length === 0) return null;

  const visibleMessages = messages.filter((message) => {
    if (message.role === 'assistant' && hideAssistantMessage) return false;
    if (message.role === 'user' && hideUserMessage) return false;
    // Hidden channel. `metadata.hidden` hides the message live, but Mastra doesn't persist it
    // for user messages — so once the session remounts from server history (or on reload) we
    // fall back to the client-side registry (matched by id or text). Legacy threads still use
    // the `[[AI_HIDDEN_PROMPT]]` text marker; keep that check until those threads age out.
    if (isHiddenMessage(message)) return false;
    if (message.role === 'user' && isRememberedHiddenMessage({ id: message.id, text: getMessageText(message) })) return false;
    if (message.role === 'user' && isHiddenAssistantPrompt(getMessageText(message))) return false;
    return true;
  });

  if (visibleMessages.length === 0) return null;

  return visibleMessages.map((message, index) => {
    return <Item key={`${message.id}-${message.role}`} message={message} isLastMessage={index === visibleMessages.length - 1} />;
  });
};

export default List;
